import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { UserService } from 'src/app/core/services/v2/user.service';

@Component({
  selector: 'app-welcome-login',
  templateUrl: './welcome-login.component.html',
  styleUrls: ['./welcome-login.component.scss']
})
export class WelcomeLoginComponent implements OnInit {

  constructor(
    private authService: AuthService,
   private userService: UserService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    console.log('WelcomeLoginComponent loaded');

    this.redirectLogin();
  }

  async redirectLogin() {
    // Check if the user is logged in
    let result = await this.authService.isLoggedIn();

    if (result) {
      // If logged in, redirect based on the user's role
      this.RedirectAccorndilyUsersRole();
    } else {
      // If not logged in, redirect to Azure AD B2C login
      this.document.location.href = `/Session/SignIn?redirectUrl=/app/userhome`;
    }
  }

  private RedirectAccorndilyUsersRole() {
    // You can keep your logic for user role redirection here
    this.userService.getUserDetails().subscribe(
      (res) => {
        if (res) {
          if (res.role == "AHIAdministrator") {
            this.router.navigate(["admin"]);
          } else if (res.role == "CaseManager") {
            this.router.navigate(["casemanager"]);
          } else if (res.isGlobalAdministrator || this.userService.rolesRoutedToPhysician.includes(res.role)) {
            this.router.navigate(["physician"]);
          } else if (res.role == "Patient") {
            this.router.navigate(["patient"]);
          } else if (res.role == "Employer") {
            this.router.navigate(["employer"]);
          } else if (res.role == "Call Care Coordinator") {
            this.router.navigate(["callcenter"]);
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
}
